/* eslint-disable  @typescript-eslint/no-explicit-any */

type LogFunction = (message?: any, ...optionalParams: any[]) => void;

export interface Logger {
    debug: LogFunction;
    info: LogFunction;
    warn: LogFunction;
    error: LogFunction;
}

export type LogLevel = 'debug' | 'info' | 'warn' | 'error';

const NO_OP: LogFunction = () => {};

export class ConsoleLogger implements Logger
{
    readonly debug: LogFunction;
    readonly info: LogFunction;
    readonly warn: LogFunction;
    readonly error: LogFunction;

    constructor(options?: { level? : LogLevel }) {
        const { level } = options || {};

        this.error = console.error.bind(console);

        if (level === 'error') {
            this.debug = NO_OP;
            this.info = NO_OP;
            this.warn = NO_OP;

            return;
        }

        this.warn = console.warn.bind(console);

        if (level === 'warn') {
            this.debug = NO_OP;
            this.info = NO_OP;

            return;
        }

        this.info = console.log.bind(console);

        if (level === 'info') {
            this.debug = NO_OP;

            return;
        }

        this.debug = console.log.bind(console);

        if (level === 'debug') {
            return;
        }

        console.error("Unsupported log level", level)
    }
}

export const logger = new ConsoleLogger({ level: import.meta.env.VITE_LOG_LEVEL });